const noDataMessage = $("#noDataMessage").val();
const loadMoreMessage = $('#loadMoreMessage').val();
const allLabel = $('#allLabel').val();
const articleBaseUrl = "/api/fe/article/getPaginateFE";
const questionBaseUrl = "/api/fe/question/getPage";
const topicBaseUrl = "/api/fe/questionType/getPaginateFE";
const questionTypeBaseUrl = "/api/fe/questionType/getPaginateFE"; 
const externaLinkBaseUrl = "/api/fe/menu/getMenuChildrenByAliasArrAndTypeTrans";
const loadMoreHtml =    `<section class="news-list-more-section">
                            <div class="load-more-wrapper">
                                <a class="load-more" href="javascript:void(0)">${loadMoreMessage}</a>
                            </div>
                        </section>`;
const emptySearchKeywordFieldMessage = $('#emptySearchKeywordFieldMessage').val();
const noResultsFound = $('#noResultsFound').val();
function escapeHTML(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
function scrollIntoView(alias){
    const targetOffsetTop = document.getElementById(`${alias}`)?.offsetTop;
    if(targetOffsetTop){
        window.scrollTo({
                top: targetOffsetTop - 60, // Menu fixed + gap
                behavior: 'instant'
        })
    }
}
function onFirstLoad(alias){
    if(!hasScrolledToView && alias === childActiveAlias){
        scrollIntoView(alias);
        hasScrolledToView = true;
    }
}
function slugWithTitleAndId(title,id){
    return `${slugify(title)}-${id}`;
}
function slugify(title){
    const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
    const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return title.toString().toLowerCase()
    .replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a')
    .replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e')
    .replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i')
    .replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o')
    .replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u')
    .replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y')
    .replace(/đ/gi, 'd')
    .replace(/\s+/g, '-') 
    .replace(p, c => b.charAt(a.indexOf(c)))
    .replace(/&/g, '-and-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}
function renderExternalLinks(element,links,alias,title,parentUrl){
    if(!links.length){
        const linkHtml = `<li class="news-item">
                <span class="news-content">
                    <a href="${parentUrl}" class="news-title" title="${title}" target="_blank">${title}</a>
                </span>
            </li>
        `;
        element.html(articlesLv2WrapperHtml(linkHtml,title,alias));  
        return;
    }
    const linksHtml = links.map(link => {
        return `<li class="news-item">
                <span class="news-content">
                    <a href="${link.url}" class="news-title" title="${link.name}" target="_blank">${link.name}</a>
                </span>
            </li>
        `
    }).join('');
    element.html(articlesLv2WrapperHtml(linksHtml,title,alias));   
}
function renderIntroductionArticle(element,articles,locale,alias,title,wrapperHtml){
    if(!articles.length){
        element.html('');
        return;
    }
    const article = articles[0];
    const articleHtml = `
        <div class="featured-introduction-article" id=${alias}>
            <div class="article-container" data-scrollbar>
                <h3 class="article-header">${article.title}</h3>
                <div class="article-content">${article.content}</div>
            </div>
        </div>
    `
    element.html(articleHtml);

    const introductionArticle = document.querySelector('.featured-introduction-article .article-container');
    if (introductionArticle) {
        window.Scrollbar.init(introductionArticle,{
            damping: 0.1,
            thumbMinSize: 10,
            alwaysShowTracks: true,
            continuousScrolling: true,
        });
    }
}
const articlesLv2WrapperHtml = (list,title,alias) =>  `
    <div class="menu-item menu-item-lv2" id=${alias}>
       <div class="menu-item-title-outer">
            <div class="menu-item-title">${title}</div>
        </div>
        <ul class="activities-news-list">${list}</ul>
    </div>
`
const menuLv3WrapperHtml = (list,title,alias) =>  `
    <div class="menu-item menu-item-lv2" id=${alias}>
        <div class="menu-item-title-outer">
            <div class="menu-item-title">${title}</div>
        </div>
        <div class="menu-lv3">${list}</div>
    </div>
`
const articlesLv3WrapperHtml = (list,title,alias) => `
    <div class="menu-item menu-item-lv3${alias === childActiveAlias ? ' open' : ''}">
        <div class="menu-item-title-outer${list ? ' active' : ''}">
            <i class="icon${list ? ' fas fa-chevron-down' : ''}"></i>
            <div class="menu-item-title">${title}</div>
        </div>
        <div class="activities-news-list-outer">
            <ul class="activities-news-list">${list}</ul>
        </div>
    </div>
`
async function fetchExternalLinks(element,alias,params,title,parentUrl){
    return new Promise((resolve,reject) => {
        element.html('<div class="loading-spinner"></div>');
        $.ajax({
            url: `${externaLinkBaseUrl}?${params}`,
            method: 'GET',
            dataType: 'json',
            success: function(response){
                renderExternalLinks(element,response,alias,title,parentUrl);
                resolve();     
            },
            error: function(){
                element.html('');
                reject();
            }
        });
    });
}
async function fetchArticles(element,locale,alias,params,title,wrapperHtml,renderCallback){
    return new Promise((resolve,reject) => {
         element.html('<div class="loading-spinner"></div>');
        $.ajax({
            url : `${articleBaseUrl}?${params}`,
            method: 'GET',
            dataType: 'json',
            success: function(response){
                const nextPage = response.current_page + 1;
                const hasMore = nextPage <= response.last_page;
                const clonedParams = new URLSearchParams(params.toString());
                clonedParams.set('page',nextPage);
                const newParams = hasMore ? clonedParams : null;
                renderCallback(element,response.data,locale,alias,title,wrapperHtml,newParams);
                resolve();
            },
            error: function () {
                element.html('');
                reject();
            },
        })
    })
}
async function fetchFields(listElement,locale,alias,title,fieldParams,articleParams){
    return new Promise((resolve,reject) => {
        listElement.html('<div class="loading-spinner"></div>');
        $.ajax({
            url : `/api/fe/field/getListByCatAlias?${fieldParams}`,
            method: 'GET',
            dataType: 'json',
            success: function(data){
                renderFieldList(listElement,data,locale,alias,title,articleParams).then(resolve).catch(reject);
            },
            error: function () {
                listElement.html('');
                reject();
            },
        })
    })
}
function renderFieldList(container,fields,locale,alias,title,articleParams){
    if(!fields.length){
        container.html(menuLv3WrapperHtml('',title,alias));
        return Promise.resolve();
    }
    container.html(menuLv3WrapperHtml(fields.map(() => '<div class="menu-item-container"></div>').join(''),title,alias));
    const menuItemContainers = container.find('.menu-item-container');
    return Promise.all(
        fields.map((field,index) => {
            articleParams.set('fieldId',field.value)
            return fetchArticles($(menuItemContainers[index]),locale,alias,articleParams,field.label,articlesLv3WrapperHtml,renderArticles)
        })
    );
}
function renderArticles(listElement,articles,locale,alias,title,wrapperHtml,params){
    if(!articles.length){
        listElement.html(wrapperHtml('',title,alias));
        return;
    }
    const articleHtml = (article) => {
        const articleTitle = locale === 'vi' ? article.title : article.title_en ?? article.title;  
        const articleUrl = article.file_url ? article.file_url : article.baseUrl ? `${article.baseUrl}/${slugWithTitleAndId(article.title,article._id)}` : `/${locale}/professtional-activities/${alias}/${slugWithTitleAndId(articleTitle,article._id)}`;
        const articleTarget = article.file_url ? '_blank' : '_self';
        return `
            <li class="news-item">
                <span class="news-content">
                    <a href="${articleUrl}" class="news-title" title="${articleTitle}" target="${articleTarget}">${articleTitle}</a>
                </span>
            </li>
        `;
    }
    let articlesHtml = articles.map(article => articleHtml(article)).join('');
    listElement.html(wrapperHtml(articlesHtml + (params ? loadMoreHtml : ''),title,alias));

    const loadMoreButton = listElement.find('.load-more');
    if(loadMoreButton.length){
        $(loadMoreButton).on('click',function(){
            fetchMoreItems($(this).parent(),params,articleHtml,articleBaseUrl);
        })
    }
}
function fetchMoreItems(element,params,itemHtml,url){
    element.html('<div class="loading-spinner"></div>');
    $.ajax({
        url: `${url}?${params}`,
        method: 'GET',
        dataType: 'json',
        success: function(response){
            const nextPage = response.current_page + 1;
            const hasMore = nextPage <= response.last_page;
            const clonedParams = new URLSearchParams(params.toString());
            clonedParams.set('page',nextPage);
            const newParams = hasMore ? clonedParams : null;
            renderMoreItems(element,newParams,response.data,itemHtml,url);
        },
        error: function(){
            element.html('');
        }
    })
}
function renderMoreItems(element,params,items,itemHtml,url){
    if(!items.length){
        element.html('');
        return;
    }
    const itemsHtml = items.map(item => itemHtml(item)).join('');
    const loadMoreSection = element.closest('.news-list-more-section');
    element.replaceWith(itemsHtml + (params ? loadMoreHtml : ''));
    const loadMoreButton = loadMoreSection.find('.load-more');
    if(loadMoreButton.length){
        $(loadMoreButton).on('click',function(){
            fetchMoreItems($(this).parent(),params,itemHtml,url);
        })
    }
}
function renderMoreMenuItemLv3(element,menuItems,alias,params,url,itemConstructCallback){
    if(!menuItems.length){
        element.html('');
        return;
    }
    const menuItemsHtml = menuItems.map(() => '<div class="menu-item-container"></div>').join('');
    const loadMoreSection = element.closest('.news-list-more-section');
    element.replaceWith(menuItemsHtml + (params ? loadMoreHtml : ''));
    const menuItemContainers = loadMoreSection.find('.menu-item-container');
    menuItems.forEach((menuItem,index) => {
        itemConstructCallback(menuItem,menuItemContainers[index]);
    });

    const loadMoreButton = loadMoreSection.find('.load-more');
    if(loadMoreButton.length){
        $(loadMoreButton).on('click',function(){
            fetchMoreMenuItemLv3($(this).parent(),alias,url,params,itemConstructCallback);
        });
    }
}
function fetchMoreMenuItemLv3(element,alias,url,params,itemConstructCallback){
    element.html('<div class="loading-spinner"></div>');
    $.ajax({
        url: `${url}?${params}`,
        method: 'GET',
        dataType: 'json',
        success: function(response){
            const nextPage = response.current_page + 1;
            const hasMore = nextPage <= response.last_page;
            const clonedParams = new URLSearchParams(params.toString());
            clonedParams.set('page',nextPage);
            const newParams = hasMore ? clonedParams : null;
            renderMoreMenuItemLv3(element,response.data,alias,newParams,url,itemConstructCallback);
        },
        error: function(){
            element.html('');
        }
    })
}
function renderQuestions(listElement,locale,alias,questions,title,params){
    const createQuestionTitle = (questionCode,questionName) => {
        return `${locale === 'vi' ? 'Câu hỏi' : 'Question'} ${questionCode}: ${questionName}`
    }
    if(!questions.length){
        listElement.html(articlesLv3WrapperHtml('',title,alias));
        return;
    }
    const questionHtml = (question) => {
        const questionName = escapeHTML(locale === 'vi' ? question.question : question.questionEn);
        const answer =  escapeHTML(locale === 'vi' ? question.answer : question.answerEn);
        if(questionName && answer){
            return `
                <li class="news-item question-item" data-question-id="${question._id}" data-question="${questionName}" data-answer="${answer}" onClick="showQuestionDetail('${question._id}')">
                    <span class="news-content">
                        <a href="javascript:void(0)" class="news-title">${createQuestionTitle(question.code,questionName)}</a>
                    </span>
                </li>
            `;
        }
        return '';
        
    }
    const questionListHtml = questions.map(question => questionHtml(question)).join('');

    listElement.html(articlesLv3WrapperHtml(questionListHtml + (params ? loadMoreHtml : ''),title,alias));
    const loadMoreButton = listElement.find('.load-more');
    if(loadMoreButton.length){
        $(loadMoreButton).on('click',function(){
            fetchMoreItems($(this).parent(),params,questionHtml,questionBaseUrl);
        })
    }
}
async function fetchQuestions(listElement,locale,alias,title,params){
    return new Promise((resolve,reject) => {
        listElement.html(`<div class="loading-spinner"></div>`);
        $.ajax({
            url:`${questionBaseUrl}?${params}`,
            method:"GET",
            dataType: 'json',
            success:function(response){
                const nextPage = response.current_page + 1;
                const hasMore = nextPage <= response.last_page;
                const clonedParams = new URLSearchParams(params.toString());
                clonedParams.set('page',nextPage);
                const newParams = hasMore ? clonedParams : null;
                renderQuestions(listElement,locale,alias,response.data,title,newParams);
                resolve();
            },
            error:function(){
                listElement.html('');
                reject();
            }
        })  
    })
}
async function renderTopicsList(container,locale,alias,topics,title,topicParams,questionParams){
    if(!topics.length){
        container.html(menuLv3WrapperHtml('',title,alias));
        return;
    }
    container.html(menuLv3WrapperHtml(topics.map(() => '<div class="menu-item-container"></div>').join('') + (topicParams ? loadMoreHtml : ''),title,alias));
    const menuItemContainers = container.find('.menu-item-container');
    const questionListConstructCallback = (topic,menuItemContainer) => {
        const newsQuestionParams = new URLSearchParams(questionParams);
        newsQuestionParams.set('txtSearch',topic.code);
        const topicName = locale === 'vi' ? topic.name : topic.nameEn;
        return fetchQuestions($(menuItemContainer),locale,alias,topicName,newsQuestionParams);
    }
    const loadMoreButton = container.find('.load-more');
    if(loadMoreButton.length){
        $(loadMoreButton).on('click',function(){
            fetchMoreMenuItemLv3($(this).parent(),alias,topicBaseUrl,topicParams,questionListConstructCallback);
        })
    }
    return Promise.all(
        topics.map((topic,index) => questionListConstructCallback(topic,menuItemContainers[index]))
    );
}
async function fetchTopics(listElement,locale,alias,title,topicParams,questionParams){
    return new Promise((resolve,reject) => {
        listElement.html('<div class="loading-spinner"></div>');
        $.ajax({
            url : `${topicBaseUrl}?${topicParams}`,
            method: 'GET',
            dataType: 'json',
            success: function(response){
                const nextPage = response.current_page + 1;
                const hasMore = nextPage <= response.last_page;
                const clonedParams = new URLSearchParams(topicParams.toString());
                clonedParams.set('page',nextPage);
                const newParams = hasMore ? clonedParams : null;
                renderTopicsList(listElement,locale,alias,response.data,title,newParams,questionParams).then(resolve).catch(reject);
            },
            error: function () {
                listElement.html('');
                reject();
            },
        })
    });
}
function fetchNestedListSelectField(listOption,params){
    $.ajax({
        url: `/api/fe/field/getNestedListSelectFieldByCatAlias?${params}`,
        method : 'GET',
        dataType: 'json',
        success : function(data){
            if(data.length){
                listOption.html(`
                    <option value="">${allLabel}</option>
                    ${data.map(field => `<option value=${escapeHTML(field.value)}>${field.label}</option>`)}    
                `)
                listOption.closest('.form-group').removeClass('d-none');
            }
            else listOption.closest('.form-group').addClass('d-none');
        },
        error : function (){
            listOption.closest('form-group').addClass('d-none');
        }
    })
}
function constructCateNewsContainer(listElement,childActivities, locale) {
    listElement.html(childActivities.map(() => '<div class="menu-item-container"></div>').join(''));
    const childActivityElements = listElement.children();
    Promise.all(
        childActivities.map((activity,index) => constructChildActivityElement($(childActivityElements[index]),activity,locale))
    ).then(() => {
        onFirstLoad(childActiveAlias);
        console.log(childActiveAlias);
    }).catch();

    // Delegated event handler
    childActivityElements.on('click', '.menu-item-title-outer', function() {
        $(this).closest('.menu-item-lv3').toggleClass('open');
    });

}
async function constructChildActivityElement(element,childActivity,locale){
    const articleParams = new URLSearchParams({
        pageSize: 8,
        typeTrans: locale,
        catAlias: childActivity.alias,
    });
    const questionParams = new URLSearchParams({
        pageSize: 8,
        typeTrans: locale,
    });
    let fieldParams;
    switch(childActivity.partialKey){
        case 'introduction':
            articleParams.append('typeTable[]','article');
            articleParams.set('pageSize',1);
            return fetchArticles(element,locale,childActivity.alias,articleParams,null,null,renderIntroductionArticle);
        case 'research-topic':
        case 'research-science':
            fieldParams = new URLSearchParams({
                catAlias: childActivity.alias,
                typeTrans: locale
            });
            articleParams.set('typeTable[]','documents');
            articleParams.set('typeTrans','vi');
            return fetchFields(element,locale,childActivity.alias,childActivity.name,fieldParams,articleParams);
        case 'policy-documents':
            fieldParams = new URLSearchParams({
                catAlias: childActivity.alias,
                typeTrans: locale
            });
            articleParams.set('typeTable[]','text');
            articleParams.set('typeTrans','vi');
            return fetchFields(element,locale,childActivity.alias,childActivity.name,fieldParams,articleParams);
        case 'media-documents':
            articleParams.set('typeTable[]','documents');
            return fetchArticles(element,locale,childActivity.alias,articleParams,childActivity.name,articlesLv2WrapperHtml,renderArticles);
        case 'videos':
            articleParams.set('typeTable[]','articleMedia');
            return fetchArticles(element,locale,childActivity.alias,articleParams,childActivity.name,articlesLv2WrapperHtml,renderArticles);
        case 'external-links':
            return fetchExternalLinks(element,childActivity.alias,articleParams,childActivity.name,childActivity.url);
        case 'question':
            const topicParams = new URLSearchParams({
                pageSize : 4
            });
            return fetchTopics(element,locale,childActivity.alias,childActivity.name,topicParams,questionParams);
        default:
            if(childActivity.isAliasNews){
                articleParams.append('typeTable[]','article');
                articleParams.append('excludeCatAlias',excludeCatAliases);
                articleParams.delete('catAlias');
            }
            return fetchArticles(element,locale,childActivity.alias,articleParams,childActivity.name,articlesLv2WrapperHtml,renderArticles);
    }
}

const activityContainer = $('#activities-cate-news-container');
const activityTabBtn = $(".activities-cate-item");
const activityLocale = activityContainer.data("locale");
const childActivities = activityTabBtn.filter(".active").data('child-activities');
const activeAlias = activityContainer.data('active-alias')
const childActiveAlias = activityContainer.data('active-child-alias')
const excludeCatAliases = activityContainer.data('exclude-cat-aliases');
let hasScrolledToView = false;
constructCateNewsContainer(activityContainer,childActivities, activityLocale ?? "vi");

$(".activities-cate-list").on("click", ".activities-cate-item", function () {
    activityTabBtn.removeClass("active");
    $(this).addClass("active");
    $('#page-title').text($(this).text());

    const activityAlias = $(this).data('activity-alias');
    const listFieldOption = $('#query-filter select[name="fieldId"]');
    fetchNestedListSelectField(listFieldOption,new URLSearchParams({
        catAlias : activityAlias,   
        typeTrans: activityLocale ?? "vi"
    }));

    const childActivities = $(this).data('child-activities');
    constructCateNewsContainer(activityContainer,childActivities, activityLocale ?? "vi");
    
});
$('body').append(`
    <div id="questionPopup" class="popup" style="display: none;">
        <div class="popup-content">
            <span class="close-btn" onclick="closePopup()">×</span>
            <div class="faq-item" style="border: none;">
                <div class="faq-question" data-bs-target="#faqPopupAnswer" aria-expanded="false" aria-controls="faqPopupAnswer">
                    <span id="popupQuestion"></span>
                </div>
                <div id="faqPopupAnswer" class="accordion-collapse collapse show" data-bs-parent="#questionPopup">
                    <div class="faq-answer" id="popupAnswer"></div>
                </div>
            </div>
        </div>
    </div>    
`);

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function highlightSearchResults(container,txtSearch,fieldId){
    const regex = new RegExp(escapeRegExp(txtSearch),'gi');
    const highlightClass = "highlight";
    if(!container || !txtSearch){
        toastr.error(emptySearchKeywordFieldMessage);
        return;
    }
    let firstMatch = false;
    const articlesTitle = container.find('.news-title');
    articlesTitle.each(function(){
        $(this).find('.highlight').each(function(){
            $(this).replaceWith($(this).html());
        });
    });
    const filteredArticlesTitle = fieldId ? container.find(`#${fieldId} .news-title`) : articlesTitle;
    filteredArticlesTitle.each(function(){
        const title = $(this);
        const originalHtml = title.html();
        const newHtml = originalHtml.replace(regex, function (match) {
            return `<span class="${highlightClass} fw-bold">${match}</span>`;
        });
        if(!firstMatch && newHtml !== originalHtml){
            firstMatch = true;
            requestAnimationFrame(() => {
                $('html, body').animate({
                    scrollTop: title.offset().top - $(window).height()/2 + title.outerHeight()/2
                },1000);
            })
    }
        title.html(newHtml);
    });
    if(!firstMatch){
        toastr.error(noResultsFound);
    }
}

$('#query-filter').on('submit',function(e){
    e.preventDefault();
    const txtSearch = $(this).find('input[name="txtSearch"]').val();
    const btnSearch = $(this).find('.btn-search');
    btnSearch.prop('disabled',true);
    const fieldId = $('select[name="fieldId"]').val();
    highlightSearchResults(activityContainer,txtSearch,fieldId);
    btnSearch.prop('disabled',false);
})
toastr.options = {
  "closeButton": true,
  "preventDuplicates": true,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",          
  "extendedTimeOut": "1000",   
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
}